<template>
	<transition
		name="expand"
		@enter="enter"
		@afterEnter="afterEnter"
		@leave="leave"
	>
		<slot/>
	</transition>
</template>
<script>
export default {
	name: 'TransitionExpand',
	methods: {
		enter(elem) {
			const width = getComputedStyle(elem).width;

			elem.style.display = 'block';
			elem.style.width = width;
			elem.style.position = 'absolute';
			elem.style.visibility = 'hidden';
			elem.style.height = 'auto';

			const height = getComputedStyle(elem).height;

			elem.style.width = null;
			elem.style.position = null;
			elem.style.visibility = null;
			elem.style.height = 0;

			getComputedStyle(elem).height;

			setTimeout(() => {
				elem.style.height = height;
			});
		},
		afterEnter(elem) {
			elem.style.height = 'auto';
		},
		leave(elem) {
			const height = getComputedStyle(elem).height;

			elem.style.height = height;

			getComputedStyle(elem).height;

			setTimeout(() => {
				elem.style.height = 0;
			});
		},
	}
}
</script>
<style scoped>
	.expand-enter-active, .expand-leave-active {
		transition: height .3s ease-in-out;
		overflow: hidden;
	}

	.expand-enter, .expand-leave-to {
		height: 0;
	}
</style>
